import { Component } from '@grafikr/components';

import parentComponent from 'components/v2-modal';

export default Component((node, context) => {
  parentComponent(node, context);
});
